import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/octicons/octicons/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "https://rubygems.org/gems/octicons"
      }}><img parentName="a" {...{
          "src": "https://img.shields.io/gem/v/octicons.svg",
          "alt": "Gem version"
        }}></img></a></p>
    <h2>{`Install`}</h2>
    <p>{`Add this to your `}<inlineCode parentName="p">{`Gemfile`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-rb"
      }}>{`gem 'octicons'
`}</code></pre>
    <p>{`Then `}<inlineCode parentName="p">{`bundle install`}</inlineCode>{`.`}</p>
    <p>{`If using a framework like Rails, please follow the `}<a parentName="p" {...{
        "href": "https://primer.style/view-components/#installation"
      }}>{`installation instructions`}</a>{` in the `}<a parentName="p" {...{
        "href": "https://primer.style/view-components"
      }}>{`Primer ViewComponents`}</a>{` documentation. `}</p>
    <h2>{`Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-rb"
      }}>{`require 'octicons'
icon = Octicons::Octicon.new("x")
icon.to_svg
# <svg class="octicon octicon-x" viewBox="0 0 16 16" width="16" height="16" version="1.1" "aria-hidden"="true"><path d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48z"></path></svg>
`}</code></pre>
    <h2>{`Documentation`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`Octicon`}</inlineCode>{` class takes two arguments. The first is the symbol of the icon, and the second is a hash of arguments representing html attributes`}</p>
    <h3><inlineCode parentName="h3">{`symbol`}</inlineCode>{` `}<em parentName="h3">{`(required)`}</em></h3>
    <p>{`This is the name of the octicon you want to use. For example `}<inlineCode parentName="p">{`alert`}</inlineCode>{`. `}<a parentName="p" {...{
        "href": "/"
      }}>{`Full list of icons`}</a></p>
    <h3>{`Options`}</h3>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`:height`}</inlineCode>{` - When setting the height to a number, the icon will scale to that size. For example, passing `}<inlineCode parentName="li">{`32`}</inlineCode>{`, will calculate the width based on the icon's natural size.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`:width`}</inlineCode>{` - When setting the width to a number, the icon will scale to that size. For example, passing `}<inlineCode parentName="li">{`32`}</inlineCode>{`, will calculate the width based on the icon's natural size.`}</li>
    </ul>
    <p>{`If both `}<inlineCode parentName="p">{`:width, :height`}</inlineCode>{` are passed into the options hash, then the icon will be sized exactly at those dimensions.`}</p>
    <h3>{`Attributes`}</h3>
    <p>{`Once initialized, you can read a few properties from the icon.`}</p>
    <h4><inlineCode parentName="h4">{`symbol`}</inlineCode></h4>
    <p>{`Returns the string of the symbol name`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-rb"
      }}>{`icon = Octicons::Octicon.new("x")
icon.symbol
# "x"
`}</code></pre>
    <h4><inlineCode parentName="h4">{`path`}</inlineCode></h4>
    <p>{`Path returns the string representation of the path of the icon.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-rb"
      }}>{`icon = Octicons::Octicon.new("x")
icon.path
# <path d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48z"></path>
`}</code></pre>
    <h4><inlineCode parentName="h4">{`options`}</inlineCode></h4>
    <p>{`This is a hash of all the `}<inlineCode parentName="p">{`options`}</inlineCode>{` that will be added to the output tag.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-rb"
      }}>{`icon = Octicons::Octicon.new("x")
icon.options
# {:class=>"octicon octicon-x", :viewBox=>"0 0 12 16", :version=>"1.1", :width=>12, :height=>16, :"aria-hidden"=>"true"}
`}</code></pre>
    <h4><inlineCode parentName="h4">{`width`}</inlineCode></h4>
    <p>{`Width is the icon's true width. Based on the svg view box width. `}<em parentName="p">{`Note, this doesn't change if you scale it up with size options, it only is the natural width of the icon`}</em></p>
    <h4><inlineCode parentName="h4">{`height`}</inlineCode></h4>
    <p>{`Height is the icon's true height. Based on the svg view box height. `}<em parentName="p">{`Note, this doesn't change if you scale it up with size options, it only is the natural height of the icon`}</em></p>
    <h4><inlineCode parentName="h4">{`keywords`}</inlineCode></h4>
    <p>{`Returns an array of keywords for the icon. The data comes from the `}<a parentName="p" {...{
        "href": "../data.json"
      }}>{`data file in lib`}</a>{`. Consider contributing more aliases for the icons.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-rb"
      }}>{`icon = Octicons::Octicon.new("x")
icon.keywords
# ["remove", "close", "delete"]
`}</code></pre>
    <h3>{`Methods`}</h3>
    <h4><inlineCode parentName="h4">{`to_svg`}</inlineCode></h4>
    <p>{`Returns a string of the svg tag`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-rb"
      }}>{`icon = Octicons::Octicon.new("x")
icon.to_svg
# <svg class="octicon octicon-x" viewBox="0 0 16 16" width="16" height="16" version="1.1" "aria-hidden"="true"><path d="M7.48 8l3.75 3.75-1.48 1.48L6 9.48l-3.75 3.75-1.48-1.48L4.52 8 .77 4.25l1.48-1.48L6 6.52l3.75-3.75 1.48 1.48z"></path></svg>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      